import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <section id="about-sec" className="about-section position-relative">
      <div className="floating-shape shape1"></div>
      <div className="floating-shape shape2"></div>

      <div className="container position-relative">
        <div className="row align-items-center g-5">
          <div className="col-lg-6" data-aos="fade-right">
            <div className="about-images position-relative">
              <div className="main-img rounded-4 overflow-hidden shadow-lg">
                <img
                  src="images/large_about.jpg"
                  alt="About IMT"
                  className="w-100 rounded-4"
                />
              </div>
              <div className="secondary-img rounded-4 shadow position-absolute">
                <img
                  src="images/small_about.jpg"
                  alt="IMT Team"
                  className="w-100 rounded-4"
                />
              </div>
              <div className="image-overlay-text">
                <h5 className="fw-bold text-white mb-0">
                  Locally Owned • Community Focused
                </h5>
              </div>
            </div>
          </div>

          <div className="col-lg-6" data-aos="fade-left">
            <div className="about-content">
              <div className="title-area mb-4 text-start position-relative">
                <div className="shadow-title">ABOUT</div>
                <span className="sub-title6 d-inline-flex align-items-center mb-2">
                  <span className="shape left me-2"></span>
                  WHO WE ARE
                  <span className="shape right ms-2"></span>
                </span>
                <h2 className="sec-title fw-bold">
                  Integrity. Precision. Reliability.
                </h2>
              </div>
              <p className="about-text">
                <strong>Integrity Materials Testing (IMT)</strong> is a locally
                owned Construction Materials Testing company proudly serving the
                Tampa Bay area. We believe in integrity, accuracy, and the power
                of community. Our dedicated team ensures that every test, every
                result, and every project is backed by expertise, reliability,
                and passion for excellence.
              </p>

              <p className="about-text">
                Whether serving private developers or public infrastructure, IMT
                delivers timely, precise results through certified professionals
                trained in CTQP and ACI standards. We are proud of our role in
                building a stronger, safer Tampa Bay.
              </p>

              <div className="btn-group mt-4">
                <a href="/services" className="btn imt-btn">
                  Explore Our Services
                </a>
                <a href="tel:+18139941164" className="btn call-btn ms-3">
                  <i className="fas fa-phone-alt me-2"></i> +1 (813) 994-1164
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
      
        .about-section {
          position: relative;
          background-color: #ffffff;
          padding: 120px 0;
          overflow: hidden;
        }

        .floating-shape {
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
          opacity: 0.4;
          animation: float 8s ease-in-out infinite alternate;
          z-index: 0;
        }


        @keyframes float {
          from { transform: translateY(0px); }
          to { transform: translateY(40px); }
        }

      
        .shadow-title {
          font-size: 100px;
          font-weight: 700;
          color: rgba(7, 115, 37, 0.05);
          position: absolute;
          top: -30px;
          left: 0;
          z-index: 0;
          text-transform: uppercase;
          letter-spacing: 4px;
        }

        .sub-title6 {
          color: #077325;
          font-weight: 600;
          text-transform: uppercase;
          font-size: 14px;
          letter-spacing: 1px;
          z-index: 2;
        }

        .sub-title6 .shape {
          width: 40px;
          height: 3px;
          background-color: #077325;
          display: inline-block;
          border-radius: 2px;
        }

        .sec-title {
          color: #0b0b0b;
          font-size: 2.2rem;
          z-index: 2;
          position: relative;
        }

      
        .about-images {
          position: relative;
          z-index: 1;
        }

        .main-img img {
          transition: transform 0.8s ease;
        }

        .secondary-img {
          width: 55%;
          bottom: -40px;
          right: -30px;
          transition: all 0.6s ease;
        }

        .about-images:hover .main-img img {
          transform: scale(1.05);
        }

        .about-images:hover .secondary-img {
          transform: translateY(-10px) scale(1.03);
        }

        .image-overlay-text {
          position: absolute;
          bottom: 10px;
          left: 15px;
          background: rgba(7, 115, 37, 0.8);
          backdrop-filter: blur(5px);
          border-radius: 12px;
          padding: 12px 18px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        }

     
        .about-content {
          position: relative;
          z-index: 2;
        }

        .about-text {
          color: #333;
          line-height: 1.7;
          font-size: 1.05rem;
          margin-bottom: 1rem;
        }

       
        .imt-btn {
          background: #077325;
          color: #fff;
          border-radius: 50px;
          padding: 10px 28px;
          font-weight: 600;
          letter-spacing: 0.5px;
          transition: all 0.3s ease;
          box-shadow: 0 6px 15px rgba(7,115,37,0.3);
        }
        .imt-btn:hover {
          background: #fff;
          color: #077325;
          border: 2px solid #077325;
          transform: translateY(-3px);
          text-decoration: none;
        }

        .call-btn {
          border: 2px solid #077325;
          color: #077325;
          border-radius: 50px;
          padding: 10px 24px;
          font-weight: 600;
          transition: all 0.3s ease;
        }
        .call-btn:hover {
          background: #077325;
          color: #fff;
          transform: translateY(-3px);
        }

       
        @media (max-width: 991px) {
          .shadow-title {
            font-size: 70px;
            top: -20px;
          }
          .secondary-img {
            display: none;
          }
          .about-section {
            padding: 80px 0;
          }
        }
      `}</style>
    </section>
  );
};

export default About;
